import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { BET_CONTACT_SUMMARY_TAB, BET_CUSTOMER_SUMMARY_TAB, BET_RENEWAL_SUMMARY_TAB, PARTNER_SHARED_ACTIVITIES_TAB, CALL_SUMMARY_TAB } from 'crm-events-components/internal/BET/timeline/constants/BETTimelineConstants';
import { canRenderBETContactSummaryTab, canRenderBETCustomerSummaryTab, canRenderBETRenewalSummaryTab, canRenderBETCallSummaryTab } from 'crm-events-components/internal/BET/permissions/helpers/BETTimelinePermissionsUtils';
import TimelineControlsV2 from './controls/TimelineControlsV2';
import { useTimelineCollapsedContext } from 'crm-events-data';
import { useTimelinePermissions, useTimelineAuthContext, useLegacyQueryParams, useSelectedTab, SubjectDependency, useSubjectContext, ENGAGEMENTS_ACTIVITY } from 'crm-events-data';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import { jsx as _jsx } from "react/jsx-runtime";
const BET_TABS = [BET_CONTACT_SUMMARY_TAB, BET_RENEWAL_SUMMARY_TAB, BET_CUSTOMER_SUMMARY_TAB, PARTNER_SHARED_ACTIVITIES_TAB, CALL_SUMMARY_TAB];
export const TimelineControlsWrapper = ({
  forceActivityTabForBET
}) => {
  const {
    selectedTab,
    setSelectedTab
  } = useSelectedTab();
  const queryParams = useLegacyQueryParams();
  const searchParamsFromUrl = queryParams && queryParams.defaultTab || '';
  const auth = useTimelineAuthContext();
  const scopes = useMemo(() => {
    return auth && auth.user ? auth.user.scopes : [];
  }, [auth]);
  const isCollapsedByDefault = useTimelineCollapsedContext();
  const {
    currentUserCanCommunicate
  } = useTimelinePermissions();
  const {
    objectType,
    subjectId
  } = useSubjectContext();
  const subject = useStoreDependency(SubjectDependency, {
    objectType,
    subjectId
  });
  const defaultTabType = useMemo(() => {
    if (searchParamsFromUrl === 'shared') {
      return PARTNER_SHARED_ACTIVITIES_TAB;
    }
    if (forceActivityTabForBET) {
      return ENGAGEMENTS_ACTIVITY;
    }
    if (canRenderBETContactSummaryTab({
      objectType,
      scopes,
      subject
    })) {
      return BET_CONTACT_SUMMARY_TAB;
    }
    if (canRenderBETRenewalSummaryTab({
      objectType,
      scopes,
      subject
    })) {
      return BET_RENEWAL_SUMMARY_TAB;
    }
    if (canRenderBETCustomerSummaryTab({
      objectType,
      scopes,
      subject
    })) {
      return BET_CUSTOMER_SUMMARY_TAB;
    }
    if (canRenderBETCallSummaryTab({
      objectType,
      scopes,
      subject
    })) {
      return CALL_SUMMARY_TAB;
    }
    return ENGAGEMENTS_ACTIVITY;
  }, [searchParamsFromUrl, forceActivityTabForBET, scopes, subject, objectType]);
  const handleTabClick = useCallback(type => {
    setSelectedTab(type);
  }, [setSelectedTab]);
  const activeTab = selectedTab || defaultTabType;
  const betTabIsSelected = BET_TABS.includes(activeTab);
  const activityTabIsSelected = activeTab === ENGAGEMENTS_ACTIVITY;
  return /*#__PURE__*/_jsx(TimelineControlsV2, {
    activityTabIsSelected: activityTabIsSelected,
    betTabIsSelected: betTabIsSelected,
    defaultSelectedTab: defaultTabType,
    isCollapsedByDefault: isCollapsedByDefault,
    onTabClick: handleTabClick,
    selectedTab: activeTab,
    subject: subject,
    subjectId: subjectId,
    objectType: objectType,
    hasCommunicatePermissions: currentUserCanCommunicate
  });
};
TimelineControlsWrapper.propTypes = {
  forceActivityTabForBET: PropTypes.bool
};
export default TimelineControlsWrapper;